import React from "react";
import { useTranslation } from "react-i18next";


const WorkSection = () => {
  const { t } = useTranslation("career"); // Hook to use translations

  return (
    <div className="container-class md:p-16 pt-0">
      <div className="p-5 md:p-[100px] space-y-10">
        <h1 className="web-heading-section">{t("why_work_with_us")}</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3 h-[352px] ">
            <div className="max-w-[239px]">
              <h1 className="title-xl mb-3 tracking-tight">{t("career_development")}</h1>
              <p className="body-medium text-[#EEEEEE99] tracking-[1px]">
                {t("career_development_description")}
              </p>
            </div>
          </div>
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
            <div className="max-w-[239px]">
              <h1 className="title-xl mb-3 tracking-tight">
                {t("work_life_balance")}
              </h1>
              <ul className="body-medium text-[#EEEEEE99] list-disc pl-6 tracking-[1px]">
                <li>
                  {t("work_life_balance_description_1")}
                </li>
                <li>
                  {t("work_life_balance_description_2")}
                </li>
              </ul>
            </div>
          </div>
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
            <div className="max-w-[239px]">
              <h1 className="title-xl mb-3 tracking-tight">{t("competitive_compensation")}</h1>
              <ul className="body-medium text-[#EEEEEE99] list-disc pl-6 tracking-[1px]">
                <li>
                  {t("competitive_compensation_description_1")}


                </li>
                <li>{t("competitive_compensation_description_2")}</li>
                <li>{t("competitive_compensation_description_3")}</li>
              </ul>
            </div>
            
          </div>
          
        </div>
      </div>

    </div>
  );
};

export default WorkSection;
